import React from 'react';
import PropTypes from 'prop-types';
import Basket from '../Basket';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import './SpecialNavigation.scss';

/* eslint-disable react/prop-types */
const Item = props => {
  /* eslint-enable react/prop-types */
  if (props.item.linkType === 'cart') {
    return (
      <li key={props.item.linkType} className="special-navigation-cart">
        <Basket country={props.country} linkText={props.item.linkText} />
      </li>
    );
  } else if (props.item.linkType === 'orders') {
    return (
      <li key={props.item.linkType} className="special-navigation-orders">
        <a
          href={localiseUrl(props.country, '/account')}
          className="special-navigation-link"
          onMouseDown={props.onTrackLink}>
          {props.item.linkText}
        </a>
      </li>
    );
  }
  return null;
};

Item.propTypes = {
  item: PropTypes.shape({
    linkType: PropTypes.string.isRequired,
    linkText: PropTypes.string,
  }),
  country: PropTypes.object.isRequired,
  onTrackLink: PropTypes.func.isRequired,
};

const SpecialNavigation = props => (
  <nav className="special-navigation">
    <ul>
      {props.navigation.map((item, i) =>
        <Item key={`item-${i}`} item={item} onTrackLink={props.onTrackLink} country={props.country} />
      )}
    </ul>
  </nav>
);

SpecialNavigation.propTypes = {
  navigation: PropTypes.array.isRequired,
  country: PropTypes.object.isRequired,
  onTrackLink: PropTypes.func,
};

export default SpecialNavigation;
